import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export default function useGetCsocSubscriptionDetailsApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  const mutation = useMutation<Error>(
    async (userId: string) => {
      const response = await ChessRestClient.get(
        'subscription/v1/get_user_orders',
        {
          params: {
            user_id: userId,
          },
        },
      );
      console.log('Csoc Subscription details = ', response.data);
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        } else if (handleOnError) {
          handleOnError(data);
        }
      },
    },
  );

  return {
    ...mutation,
  };
}
